module.exports = __webpack_public_path__ + "teqbahn-assets/media/project_3.ce69cf65.png";